import { CourseificPlayer } from '@st/courseific'
import { useState } from 'react'
import { useProcess, useSelect } from '~/store'
import { courseView } from './courses-module'
import { oneHourCourse } from './one-hour-course-manifest'

export function OneHourCoursePage() {
  const [activeLessonId, setActiveLessonId] = useState<string>()
  const courses = useProcess('courses')
  const view = useSelect('courses', courseView)

  return (
    <>
      {view.progressLoadFailed && (
        <div
          className="flex items-center justify-center gap-2 bg-red-100 px-4 py-3 text-sm font-semibold text-red-800"
          role="alert"
        >
          Course progress couldn't be loaded.
          <button
            className="underline"
            type="button"
            onClick={() => courses.send({ type: 'retryProgressLoad' })}
          >
            Retry
          </button>
        </div>
      )}
      <CourseificPlayer
        course={oneHourCourse}
        activeLessonId={activeLessonId}
        completedLessonIds={view.completedLessonIds}
        completed={view.completionStatus == 'completed'}
        courseCompletionFailed={view.completionStatus == 'failed'}
        onCourseCompletionRetry={() => {
          courses.send({ type: 'retryMarkCourseCompleted' })
        }}
        onLessonSelect={(lesson) => setActiveLessonId(lesson.id)}
        onLessonCompleted={(lesson) => {
          courses.send({
            type: 'lessonCompleted',
            lessonId: lesson.id
          })
        }}
      />
    </>
  )
}
